import { ClientOverviewSection } from "./overview.types";

/** Placeholder overview until get-client-overview is live. Not live counts. */
export const MOCK_CLIENT_OVERVIEW_SECTIONS: ClientOverviewSection[] = [
  {
    section: "costs",
    label: "Costs",
    applicationType: {
      key: "costs",
      name: "Costs",
      encryptedId: "mock-costs",
    },
    stats: [
      { key: "total", label: "Total", value: 70 },
      { key: "processing", label: "Processing", value: 1 },
      { key: "inbox", label: "Inbox", value: 6 },
      { key: "toReview", label: "To Review", value: 1 },
      { key: "ready", label: "Ready", value: 68 },
      { key: "exported", label: "Exported", value: 4 },
      { key: "archive", label: "Archive", value: 2 },
    ],
  },
  {
    section: "supplierStatements",
    label: "Supplier statements",
    applicationType: {
      key: "supplierStatements",
      name: "Supplier statements",
      encryptedId: "mock-supplier-statements",
    },
    stats: [
      { key: "total", label: "Total", value: 15 },
      { key: "processing", label: "Processing", value: 1 },
      { key: "inbox", label: "Inbox", value: 5 },
      { key: "toReview", label: "To Review", value: 1 },
      { key: "ready", label: "Ready", value: 13 },
      { key: "archive", label: "Archive", value: 4 },
    ],
  },
  {
    section: "bankStatements",
    label: "Bank statements",
    applicationType: {
      key: "bankStatements",
      name: "Bank statements",
      encryptedId: "mock-bank-statements",
    },
    stats: [
      { key: "total", label: "Total", value: 12 },
      { key: "collected", label: "Collected", value: 2 },
      { key: "processed", label: "Processed", value: 10 },
      { key: "transactions", label: "Transactions", value: 175 },
    ],
  },
];
